import '../style.scss';
import { MultiSelections } from 'views/mutual/inputRadio';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { RequirementCompliance } from './hooks';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { useOverseasRealEstateRequirementsCheck } from './hooks';

export type RequirementComplianceProps = {
  selected: RequirementCompliance | null,
  onChange: (value: RequirementCompliance) => void,
  error?: string,
}

export const OverseasRealEstateFatcaRequirementsCheck = ({navigate}: {navigate: () => void}) => {
  const { formik, requirementComplianceProps, buttonDisabled} = useOverseasRealEstateRequirementsCheck(navigate);
  useCustomLocationName('日米租税条約に関する確認');
  return (
    <form className="requirements-check" onSubmit={formik.handleSubmit}>
      <div className="requirements-check_description-wrapper">
        <span>
          <span className="requirements-check_description-wrapper_description-is-emphasis">{'日米租税条約第22条第1項に規定する日本国の居住者に該当することの確認'}</span>
          <span>{'についてご回答をお願いします。'}</span>
        </span>
      </div>

      <span className="requirements-check_description-wrapper_description">
        {'以下の事項につき該当する項目へチェック（✓）を入れてください。'}
      </span>
      <RequirementComplianceSelections {...requirementComplianceProps}/>
      <div className='requirements-check_button-wrapper'>
        <Button
          type={ButtonType.Submit}
          label={"回答する"}
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
          disable={buttonDisabled}
        />
      </div>      
    </form>          
  );
}

const RequirementComplianceSelections = (requirementComplianceProps: RequirementComplianceProps) => {
  return (
    <div className='overseas-real-estate-fatca_multi-selections-wrapper'>
      <MultiSelections
        items={[
          { label: '当社は、以下の要件をいずれも満たします。', value: RequirementCompliance.Compliant,
            additional: 
            <div className="requirements-check_description-wrapper requirement-compliance">
              <span className="requirements-check_description-wrapper_description">
                  {'・当社の株式その他の持分の50%以上が日本の居住者である個人、政府、日本銀行等、年金基金等に所有されている法人であること'}
              </span>
              <span className="requirements-check_description-wrapper_description">
                  {'・当該課税年度の課税所得上控除可能な支出のうち、租税条約の締結国（日本および米国）居住者以外に支払われた、又は支払われるべき額の割合が50%未満であること'}
              </span>
          </div>
          },
          { label: '当社は、上記の要件を満たしません。', value: RequirementCompliance.NonCompliant,
          },
        ]}
        name="requirementCompliance"
        {...requirementComplianceProps}
      />
    </div>
  );
};